
export const OEFeatureAccessTypes = {
    none:                               'none',
    full:                               'full',
    licensing:                          'licensing',
    
    isOne: function(candidate)  {
        return candidate === this.none || candidate === this.full || candidate === this.licensing;
    }
};

export const OELicensingEdition = {
    none:                               'None',
    viewer:                             'Viewer',
    basic:                              'Basic',
    singleUser:                         'Single User',
    extended:                           'Extended',
    professional:                       'Professional',
    branchOffice:                       'Branch Office',
    master:                             'Master',
};

OELicensingEdition.all = [
    OELicensingEdition.none,
    OELicensingEdition.viewer,
    OELicensingEdition.basic,
    OELicensingEdition.singleUser,
    OELicensingEdition.extended,
    OELicensingEdition.professional,
    OELicensingEdition.branchOffice,
    OELicensingEdition.master
];

OELicensingEdition.allAbove = function(edition)    {
    let index = OELicensingEdition.all.findIndex(e => e === edition);
    if(index < 0)   return [];
    return OELicensingEdition.all.filter((e, i) => i >= index);
};

export const OEAppInitResultCode = {
    error:                              0,
    ok:                                 1,
    aborted:                            -(1 << 16),

    toString(code)    {
        const strs = [
            'error',
            'ok',
            'aborted'
        ];
    
        return typeof(code) === 'number' && code >= 0 && code < strs.length ? strs[code] : 'unkown';
    }
};

export const OEAppStatusErrorCode = {
    couldNotLoadModel:                  0,
    couldNotLoadResource:               1,
    couldNotLoadPres:                   2,
    couldNotLoadLinkRef:                3,
    couldNotLoadUILinkRef:              4,
    couldNotApplyLinkRef:               5,
    couldNotApplyUILinkRef:             6,
    notReady:                           7,
    unexpected:                         8,

    toDesc(code)    {
        const descs = [
            'Loading model failed.',
            'Downloading resource failed.',
            'Downloading presentation failed.',
            'Downloading deep link (model) failed.',
            'Downloading deep link (ui) failed.',
            'Application of deep link (model) failed.',
            'Application of deep link (ui) failed.',
            'Application not ready.',
            'Unexpected Error.'
        ];
    
        let code_ = typeof(code) === 'number' && code >= 0 && code < descs.length ? code : OEAppStatusErrorCode.unexpected;
        return descs[code_];
    }
};

export class OEAppStatusError   {

    constructor(code, desc, localizedDesc) {
        this.init(code, desc, localizedDesc);
    }

    init(code = OEAppStatusErrorCode.unexpected, desc, localizedDesc = '')  {
        this.code = typeof(code) === 'number' ? code : OEAppStatusErrorCode.unexpected;
        this.desc = typeof(desc) === 'string' ? desc : OEAppStatusErrorCode.toDesc(this.code);
        this.localizedDesc = typeof(localizedDesc) === 'string' ? localizedDesc : '';
        return this;
    }

    initWithError(error)  {
        this.init(error.code, error.desc, error.localizedDesc);
        return this;
    }
}

export class OEChangeTargetResult   {

    constructor(code, changed, target, error) {
        this.init(code, changed, target, error);
    }

    init(code = OEAppInitResultCode.ok, changed = false, target = '', error) {
        this.code = typeof(code) === 'object' && code && typeof(code.value) === 'number' ? code.value : (typeof(code) === 'number' ? code : OEAppInitResultCode.ok);
        this.changed = !!changed;
        this.target = typeof(target) === 'string' ? target : '';
        this.error = error ? new OEAppStatusError(error) : undefined;
        return this;
    }

    initWithResult(result)  {
        this.init(result.code, result.changed, result.target, result.error);
        return this;
    }

    toString(inset = '')  {
        let ret = 'code: ' + OEAppInitResultCode.toString(this.code) + '\n' + inset +
                'changed: ' + this.changed.toString() + '\n' + inset +
                'target: ' + this.target;

        if(this.error)  {
            ret += '\n' + inset + 'error: ' + this.error.desc;
        }
        
        return ret;
    }
}

export const OEAppInitResult = OEChangeTargetResult;

export const UIControllerType = {
    dummy:                              0,
    cut:                                1,
    arrow:                              2,
    note:                               3,
    component:                          4,
    substructure:                       5,
    search_tool:                        6,
    selection_manager:                  7,
    selection:                          8,
    context_menu:                       9,
    model_state:                        10,
    label:                              11,
    presentation:                       12,
    animation:                          13,
    timeline:                           14,
    media_center:                       15,
    settings:                           16,
    info:                               17,
    licensing_manager:                  18,
    highlighting_tooltip:               19,
    feature_access:                     20,
    color:                              21,
    explosion:                          22,
    media:                              23,
    audio_player:                       24,
    preset:                             25,
    color_theme:                        26,
    tutor:                              27,
    search_controller:                  28,
    user_object:                        29,
    misc:                               30,
    app:                                31,
    vp_gizmo:                           32,
    camera:                             33
};

export const UILockFlags = {
    none:                               0,
    visibility:                         1,
    presentability:                     2,
    enable:                             4,
    vp:                                 3,
    ve:                                 5,
    pe:                                 6,
    vpe:                                7
};

export const AMErrorType = {
    noError:                            0,
    unexpected:                         1,
    couldNotOpenFile:                   2,
    fileIsCorrupt:                      3,
    unsupportedAudioFormat:             4,
    unsupportedFileType:                5,

    stringTable: ['noError', 'unexpected', 'couldNotOpenFile', 'fileIsCorrupt', 'unsupportedAudioFormat', 'unsupportedFileType'],

    toString: function(type) {
        return typeof(type) !== 'number' || type < 0 || type >= this.stringTable.length ? undefined : this.stringTable[type];
    }
};

export const OELanguageCode = {
    unset:                              'Unset',
    english:                            'EN',
    german:                             'DE',
    chinese:                            'ZH',
    italian:                            'IT',
    dutch:                              'NL',
    korean:                             'KO',
    japanese:                           'JA',
    finnish:                            'FI',
    portugese:                          'PT',
    swedish:                            'SV',
    czech:                              'CS',
    spanish:                            'ES',
    french:                             'FR',
    greek:                              'EL'
};

export const OELanguageType = {
    unknown:                            -1,
    unset:                              -1,
    english:                            0,
    german:                             1,
    chinese:                            2,
    italian:                            3,
    dutch:                              4,
    korean:                             5,
    japanese:                           6,
    finnish:                            7,
    portugese:                          8,
    swedish:                            9,
    czech:                              10,
    spanish:                            11,
    french:                             12,
    greek:                              13,
    first:                              -1,
    last:                               13,

    codeTable: ['Unset', 'EN', 'DE', 'ZH', 'IT', 'NL', 'KO', 'JA', 'FI', 'PT', 'SV', 'CS', 'ES', 'FR', 'EL'],

    toCode: function(type)  {
        return typeof(type) !== 'number' || type + 1 < 0 || type + 1 >= this.codeTable.length ? undefined : this.codeTable[type + 1];
    },

    fromCode: function(code)    {
        let index = this.codeTable.findIndex(c => c === code);
        return index >= 0 ? index - 1 : undefined;
    },

    sanitize: function(type, allowUnset = true, defaultType = 0) {
        if(typeof(type) !== 'number' || type < this.first || type > this.last || (!allowUnset && type === this.unset))  {
            defaultType = typeof(defaultType) === 'number' && defaultType >= this.first && defaultType <= this.last ? defaultType : this.english;
            return defaultType;
        }
        return type;
    }
};

export const OEFeature = {
    tree:                               0,
    substructure:                       1,
    color:                              2,
    explosion:                          3,
    cut:                                4,
    arrows:                             5,
    notes:                              6,
    labels:                             7,
    search:                             8,
    selection:                          9,
    context_menu:                       10,
    presentation:                       11,
    play_pres:                          12,
    edit_pres:                          13,
    media:                              14,
    animations:                         15,
    state_collection:                   16,
    tooltip:                            17,
    highlight:                          18,
    screenshot:                         19,
    user_objects:                       20
};

export const OEHideFlags = {
    none:                               0,
    scene:                              1,
    ui:                                 2,

    fromArray: function(array)  {
        if(!Array.isArray(array))   return 0;
        let ret = 0;
        array.forEach(v => {
            ret = ret | v;
        });
        return ret;
    }
};

export const OERenderMode = {    // corresponds to scene::render_mode
    opaque:                             0,
    transparent:                        1,
    hide:                               2,
    indefinite:                         3,
};

export const OEMediaType = {    // corresponds to func::MediaType
    dummy:                              0,
    image:                              1,
    video:                              2,
    web:                                3,
    pdf:                                4
};

export const OEAppResetFlags = {
    none:                               0,
    searchController:                   1 << 0,
    startState:                         1 << 1,
    uiController:                       1 << 2,
    animation:                          1 << 3,
    presentation:                       1 << 4,
    timeline:                           1 << 5,
    accessory:                          1 << 6,
    mediaCenter:                        1 << 7,
    cutMode:                            1 << 8,
    cutComponentsMode:                  1 << 9,
    all:                                1023,
    def:                                1023,
};

OEAppResetFlags.reduced = OEAppResetFlags.timeline | OEAppResetFlags.accessory | OEAppResetFlags.cutMode | OEAppResetFlags.cutComponentsMode;